import React from 'react';
import PropTypes from 'prop-types';
import {
  PROFILE_BLOCK,
  PROFILE_BLOCKS,
} from '../../../../services/utilityFunctions';
import SocialMediaIcon from './SocialMediaIcon';
import CompanyIcon from './CompanyIcon';
import InfoIcon from './InfoIcon';
import SoftSkillsIcon from './SoftSkillsIcon';
import LegalFinancesIcon from './LegalFinancesIcon';
import ContactsIcon from './ContactsIcon';
import HobbiesIcon from './HobbiesIcon';
import CareerIcon from './CareerIcon';
import HardSkillsIcon from './HardSkillsIcon';
import LanguagesIcon from './LanguagesIcon';
import MoodIcon from './MoodIcon';
import MediaIcon from './MediaIcon';
import DocumentsIcon from './DocumentsIcon';
import ExperienceIcon from './ExperienceIcon';

export default function ProfileBlockIcon({ block }) {
  switch (block) {
    case PROFILE_BLOCK.SOCIAL_MEDIA:
      return <SocialMediaIcon />;
    case PROFILE_BLOCK.COMPANY:
      return <CompanyIcon />;
    case PROFILE_BLOCK.INFO:
      return <InfoIcon />;
    case PROFILE_BLOCK.SOFT_SKILLS:
      return <SoftSkillsIcon />;
    case PROFILE_BLOCK.LEGAL_FINANCES:
      return <LegalFinancesIcon />;
    case PROFILE_BLOCK.CONTACTS:
      return <ContactsIcon />;
    case PROFILE_BLOCK.HOBBIES:
      return <HobbiesIcon />;
    case PROFILE_BLOCK.CAREER:
      return <CareerIcon />;
    case PROFILE_BLOCK.HARD_SKILLS:
      return <HardSkillsIcon />;
    case PROFILE_BLOCK.LANGUAGES:
      return <LanguagesIcon />;
    case PROFILE_BLOCK.MOODS:
      return <MoodIcon />;
    case PROFILE_BLOCK.MEDIA:
      return <MediaIcon />;
    case PROFILE_BLOCK.AVAILABILITY:
      return <i className="fa fa-calendar availability-icon" />;
    case PROFILE_BLOCK.DOCUMENTS:
      return <DocumentsIcon />;
    case PROFILE_BLOCK.EXPERIENCE:
    default:
      return <ExperienceIcon />;
  }
}

ProfileBlockIcon.propTypes = {
  block: PropTypes.oneOf(PROFILE_BLOCKS).isRequired,
};
